import {Observable} from 'rxjs';
import {DataStorageService} from 'shared/services/data-storage.service'; // NOSONAR

import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';

import {AnalyseStarterService} from 'shared/services/analyse-starter.service';

@Injectable({
  providedIn: 'root'
})
export class ResultGuard {
  constructor(
    private readonly storage: DataStorageService,
    private readonly analyseStarted: AnalyseStarterService,
    private readonly router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.checkHasResultOrRedirect(next);
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.checkHasResultOrRedirect(next);
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.hasResult();
  }

  public async hasResult(): Promise<boolean> {
    return (
      (await this.storage.getDisclaimerRead()) &&
      (await this.storage.getResultData()).anzahlMaGesamt > 0
    );
  }

  private async checkHasResultOrRedirect(
    next: ActivatedRouteSnapshot
  ): Promise<boolean | UrlTree> {
    const hasResult = await this.hasResult();
    if (hasResult) {
      return true;
    }
    return this.router.parseUrl('/home');
  }
}
